module.exports = __webpack_public_path__ + "static/media/8b.4acf83ea.svg";